import moment from "moment";
import { LOCAL_STORAGE_SERVICE } from "../../core/services/storage-service";
import {
  FRONTOFFICE_AUTHORITIES_ROUTE_MAP,
  BACKOFFICE_AUTHORITIES_ROUTE_MAP,
} from "../models/authorities-route-map";
import { ProgressBar } from "../components/progress-bar/progress-bar";
import { SpecialLabelCases } from "../models/utilities";
// import { Icon } from "../icons/icon";
import { ToolTip } from "../components/tooltip/tooltip";
import {
  hasFilterValues,
} from "./filter-helper";

function toCurrencyFormat(data) {
  if (data === -1) {
    return "Infinity";
  }
  if (data) {
    data = parseFloat(data) / 100;
    return (
      "₦" +
      parseFloat(data)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,")
    );
  } else {
    return "₦0.00";
  }
}

function toNumberFormat(value) {
  return new Intl.NumberFormat().format(value);
}

function toMinorAmount(amountInMajor) {
  const value = Number(amountInMajor);
  return value ? value * 100 : 0;
}

function toMajorAmount(amountInMinor) {
  const value = Number(amountInMinor);
  return value ? value / 100 : 0;
}

function formatDate(date) {
  if (typeof date === "object") {
    if (date) {
      let dateLength = date?.length;
      if (dateLength && dateLength === 7) {
        // removes millisecond
        date.pop();
      }
      return `${moment(date, "YYYY MM DD HH mm ss").format(
        "MMM Do YY"
      )} | ${moment(date, "YYYY MM DD HH mm ss").format("LTS")}`;
    } else {
      return "------";
    }
  } else {
    return `${moment(date).format("MMM Do YY")} | ${moment(date).format(
      "LTS"
    )}`;
  }
}

function formatDateOnly(date) {
  if (!date) {
    return "------";
  }
  if (date && typeof date === "object") {
    let dateLength = date?.length;
    if (dateLength && dateLength === 7) {
      // removes millisecond
      date.pop();
    }
    return `${moment(date, "YYYY MM DD HH mm ss").format("MMM DD, YYYY")}`;
  } else {
    return `${moment(date).format("MMM DD, YYYY")}`;
  }
}

function formatDateInMilliseconds(date) {
  if (date) {
    return `${moment(date).format("MMM Do YY")} | ${moment(date).format(
      "LTS"
    )}`;
  } else {
    return "------";
  }
}

function setCountdown(date) {
  if (!date) {
    return `${0} Day(s) ${0} Hours ${0} minutes ${0} seconds`;
  }
  let countdownDate;
  if (typeof date === "object") {
    // Remove millisicond from end of date array to allow proper handling of date
    if (date.length > 6) {
      date.pop();
    }
    let disputeExpiryDate = [...date];
    // Subtract one from the month at position 1 because date format months start at 0
    --disputeExpiryDate[1];
    countdownDate = new Date(...disputeExpiryDate).getTime();
  } else {
    countdownDate = new Date(date).getTime();
  }
  const now = new Date().getTime();
  const distance = countdownDate - now;
  if (!distance || distance < 0) {
    return `${0} Day(s) ${0} Hours ${0} minutes ${0} seconds`;
  } else {
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    return `${days} Day(s) ${hours} Hours ${minutes} minutes ${seconds} seconds`;
  }
}
function getExpiryHour(date) {
  if (!date) {
    return null;
  }
  let expiryDate;
  if (typeof date === "object") {
    let disputeExpiryDate = [...date];
    // Subtract one from the month at position 1 because date format months start at 0
    --disputeExpiryDate[1];
    expiryDate = new Date(...disputeExpiryDate).getTime();
  } else {
    expiryDate = new Date(date).getTime();
  }

  var now = new Date().getTime();
  var distance = expiryDate - now;
  if (distance < 0) {
    return null;
  } else {
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    if (days < 1) {
      return hours;
    } else {
      return null;
    }
  }
}

function responseCodeColor(responseCode) {
  switch (responseCode) {
    case "00":
      return (
        <span
          className="custom-badge custom-badge-code"
          style={{
            backgroundColor: "#37AC00",
            fontWeight: "600",
            color: "#ffffff",
          }}
        >
          {responseCode}
        </span>
      );
    case "91":
    case "92":
    case "96":
    case "22":
    case "06":
      return (
        <span
          className="custom-badge custom-badge-code"
          style={{
            backgroundColor: "#f44435",
            fontWeight: "600",
            color: "#ffffff",
          }}
        >
          {responseCode}
        </span>
      );
    default:
      return (
        <span
          className="custom-badge custom-badge-code"
          style={{
            backgroundColor: "#50B8EE",
            fontWeight: "600",
            color: "#ffffff",
          }}
        >
          {responseCode}
        </span>
      );
  }
}

function titleCase(str) {
  if (str === null || str === "" || !str) return false;
  else str = str.toString();

  str = str.split("_").join(" ");

  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function getProcessError(error, specialCase = null) {
  const errorData = error?.data?.errors;
  const err = error?.data?.error
    ? [`${error?.data?.error}`]
    : ["Something went wrong ..."];
  const errors = errorData?.length ? errorData : err;

  let result = "";
  errors.forEach((e) => {
    result += e.message
      ? specialCase === "NAME_ENQUIRY" || specialCase === "TOAST"
        ? e.message
        : `${e.message}`
      : e;
  });
  return result;
  // }
}

async function parseBlobError(error) {
  const parsedError = JSON.parse(await error?.data?.text());
  const errors = parsedError?.errors
    ? parsedError?.errors
    : parsedError?.error
    ? [parsedError?.error]
    : ["Something went wrong..."];
  let errMessage = "";
  errors.forEach((error) => {
    errMessage += error?.message ? error?.message : error;
  });
  return errMessage;
}

function percentageStatus(value) {
  if (value === null) {
    return "------";
  } else {
    return <ProgressBar value={value} />;
  }
}

function settlementWarningStatus(response) {
  return (
    <div className="flex default">
      <span className="custom-badge custom-badge-text custom-badge-warning">
        {titleCase(response.toLowerCase())}
      </span>
      {/* <Icon icon="warning-status" /> */}
      <ToolTip
        tip="Settlements need to be processed manually."
        icon="warning-status"
      />
    </div>
  );
}

function responseStatus(response, property) {
  const successfulStatuses = [
    "successCount",
    "success",
    "available",
    "successful",
    "ok",
    "credit",
    "accepted",
    "resolved",
    "approved",
    "active",
    "completed",
    "created",
    "true",
    "activated",
  ];
  const warningStatuses = ["uploadTotalCount", "pending"];
  const errorStatuses = [
    "declined",
    "debit",
    "failed",
    "blocked",
    "deleted",
    "rejected",
    "deactivated",
  ];
  if (typeof response === "number") {
    switch (property) {
      case "uploadTotalCount":
        return (
          <span className="custom-badge custom-badge-text custom-badge-pending">
            {response}
          </span>
        );
      case "successCount":
        return (
          <span className="custom-badge custom-badge-text custom-badge-success">
            {response}
          </span>
        );
      case "failedCount":
        return (
          <span className="custom-badge custom-badge-text custom-badge-error">
            {response}
          </span>
        );
      default:
        return;
    }
  }
  const status = response ? response?.toString()?.toLowerCase() : response;
  let statusToDisplay = titleCase(status);
  if (!response) {
    return "------";
  }
  if (successfulStatuses.includes(status)) {
    return (
      <span className="custom-badge custom-badge-text custom-badge-success">
        {statusToDisplay}
      </span>
    );
  } else if (warningStatuses.includes(status)) {
    return (
      <span className="custom-badge custom-badge-text custom-badge-pending">
        {statusToDisplay}
      </span>
    );
  } else if (errorStatuses.includes(status)) {
    return (
      <span className="custom-badge custom-badge-text custom-badge-error">
        {statusToDisplay}
      </span>
    );
  } else if (status === "") {
    return "------";
  } else {
    return (
      <span className="custom-badge custom-badge-text custom-badge-warning">
        {statusToDisplay}
      </span>
    );
  }
}

function toTitleCase(str) {
  if (str) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }
  return str;
}

function toUrlString(obj) {
  let urlString = "";
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      if (obj[prop] != null && obj[prop].constructor === Array) {
        urlString = createUrlString(obj[prop], prop);
      } else {
        urlString += prop + "=" + encodeURIComponent(obj[prop]) + "&";
      }
    }
  }
  return urlString.substr(0, urlString.length - 1);
}

function createUrlString(arr, prop) {
  let urlString = "";
  arr.forEach((i) => {
    urlString += `${prop}=${i}&`;
  });
  return urlString;
}

function getRefineRole() {
  const roles = LOCAL_STORAGE_SERVICE.GET_ROLES();
  switch (roles[0]) {
    case "DCIR_BACKOFFICE_ADMIN":
      return "Backoffice Admin";
    case "DCIR_MERCHANT_SUPER_ADMIN":
      return "Super Agent Admin";
    case "DCIR_BACKOFFICE_OPERATOR":
      return "Backoffice Operator";
    default:
      return roles[0]?.split("_")?.join(" ")?.toLowerCase();
  }
}

function getUserLoginRoute(authorities) {
  let roleType;
  for (let i = 0; i < authorities.length; i++) {
    let authorityArr = authorities[i].split("_");
    if (authorityArr.includes("bo")) {
      roleType = "back-office";
      break;
    } else if (authorityArr.includes("fo")) {
      roleType = "front-office";
      break;
    }
  }
  let route = getRouteFromAuthorities(roleType, authorities);
  return route ? `/${roleType}/${route}` : `/account/change-password`;
}

function getRouteFromAuthorities(roleType, authorities) {
  let route;
  if (roleType === "back-office") {
    let routeKeys = Object.keys(BACKOFFICE_AUTHORITIES_ROUTE_MAP);
    for (let i = 0; i < routeKeys.length; i++) {
      if (authorities.includes(routeKeys[i])) {
        route = BACKOFFICE_AUTHORITIES_ROUTE_MAP[routeKeys[i]];
        break;
      }
    }
  } else {
    let routeKeys = Object.keys(FRONTOFFICE_AUTHORITIES_ROUTE_MAP);
    for (let i = 0; i < routeKeys.length; i++) {
      if (authorities.includes(routeKeys[i])) {
        route = FRONTOFFICE_AUTHORITIES_ROUTE_MAP[routeKeys[i]];
        break;
      }
    }
  }
  return route;
}

function hasAuthority(authority) {
  if (authority === "all") {
    return true;
  }
  const authorities = LOCAL_STORAGE_SERVICE.GET_AUTHORITIES();
  return authorities.includes(authority);
}

function hasRole(rolesArray) {
  let hasRole = false;
  const roles = LOCAL_STORAGE_SERVICE.GET_ROLES();
  rolesArray.forEach((e) => {
    if (roles.includes(e)) {
      hasRole = true;
    }
  });
  return hasRole;
}

function canPerformAction(authorities, action) {
  let authority = "";
  authorities.forEach((e) => {
    if (e.label === action) {
      authority = e.value;
    }
  });

  return hasAuthority(authority);
}

function getDateDifference(startDate, endDate) {
  let startDateObj = new Date(startDate);
  let endDateObj = new Date(endDate);
  let dateDifference =
    Math.abs(startDateObj.getTime() - endDateObj.getTime()) /
    1000 /
    60 /
    60 /
    24;
  return dateDifference;
}

function removeEmptyValues(obj) {
  const propNames = Object.getOwnPropertyNames(obj);
  // @ts-ignore
  propNames.forEach((propName) => {
    if (
      obj[propName] === null ||
      obj[propName] === undefined ||
      obj[propName] === "undefined" ||
      String(obj[propName]) === ""
    ) {
      delete obj[propName];
    }
  });
  return obj;
}

function getDisputeDetailsArray(dispute) {
  let arr = [];

  // let refundTransactionArr;
  // for (const property in dispute) {
  //   if (dispute.hasOwnProperty(property)) {
  //     console.log("dispute", property);
  //     if (dispute[property] && property === "refundTransaction") {
  //       refundTransactionArr = getDetailsArray(dispute?.refundTransaction);
  //       refundTransactionArr = refundTransactionArr.filter(
  //         (tran) => tran.label !== "Status"
  //       );
  //     } else {
  //       if (
  //         dispute[property] &&
  //         (typeof dispute[property] === "string" ||
  //           typeof dispute[property] === "number") &&
  //         property !== "statusLogInfo"
  //       ) {
  //         let disputeValue = {
  //           label: camelToTitleCase(property),
  //           value: String(dispute[property]),
  //           itemCase: property,
  //         };
  //         arr.push(disputeValue);
  //       }
  //     }
  //   }
  // }
  // let returnValue = arr.concat(refundTransactionArr);
  // return returnValue;

  arr.push({
    label: "Customer Account No",
    value: dispute?.customerAccountNumber,
    itemCase: "customerAccountNumber",
  });
  arr.push({
    label: "Status",
    value: dispute?.status,
    itemCase: "status",
  });
  arr.push({
    label: "Resolution Status",
    value: dispute?.resolutionStatus,
    itemCase: "resolutionStatus",
  });
  arr.push({
    label: "Transaction Amount",
    value: dispute?.transactionAmount,
    itemCase: "transactionAmount",
  });
  arr.push({
    label: "Transaction Status",
    value: dispute?.transactionStatus,
    itemCase: "transactionStatus",
  });
  arr.push({ label: "Comment", value: dispute?.comment });

  arr.push({ label: "Log Code", value: dispute?.logCode });
  arr.push({ label: "Logged By", value: dispute?.loggedBy });
  arr.push({ label: "Reopened By", value: dispute?.reopenedBy });
  arr.push({
    label: "Logged On",
    value: dispute?.loggedOn,
    itemCase: "createdOn",
  });
  arr.push({
    label: "Payment Facilitator Id",
    value: dispute?.paymentFacilitatorId,
  });
  arr.push({
    label: "Payment Facilitator Name",
    value: dispute?.paymentFacilitatorName,
  });
  arr.push({
    label: "TAT Expiry Date",
    value: dispute?.tatExpiryDate,
    itemCase: "tatExpiryDate",
  });
  arr.push({
    label: "Mandate Reference",
    value: dispute?.mandateReference,
    itemCase: "mandateReference",
    action: "viewMandate",
  });
  arr.push({ label: "Reason", value: dispute?.reason });
  arr.push({ label: "Resolved By", value: dispute?.resolvedBy || "___" });

  arr.push({
    label: "Transaction Reference",
    value: dispute?.transactionReference,
    action: "viewTransaction",
    transactionDetails: dispute,
  });
  arr.push({
    label: "Transaction Time",
    value: dispute?.transactionTime,
    itemCase: "createdOn",
  });

  if (dispute?.refundTransaction) {
    arr.push({
      label: "Refund Status",
      value: dispute?.refundTransaction?.status,
      itemCase: "status",
    });
    arr.push({
      label: "Refund Amount",
      value: dispute?.refundTransaction?.amount,
      itemCase: "transactionAmount",
    });
    arr.push({
      label: "Refund Destination Account",
      value: dispute?.refundTransaction?.destinationAccount,
    });
    arr.push({
      label: "Refund Destination Account Name",
      value: dispute?.refundTransaction?.destinationAccountName,
    });
    arr.push({
      label: "Refund Source Account",
      value: dispute?.refundTransaction?.sourceAccount,
    });
    arr.push({
      label: "Refund Source Account Name",
      value: dispute?.refundTransaction?.sourceAccountName,
    });
    arr.push({
      label: "Refund Request Creation Time",
      value: dispute?.refundTransaction?.createdOn,
      itemCase: "createdOn",
    });
    arr.push({
      label: "Refund Last Update Time",
      value: dispute?.refundTransaction?.lastUpdatedTime,
      itemCase: "createdOn",
    });
    arr.push({
      label: "Refund Attempts",
      value: dispute?.refundTransaction?.attempts,
    });
    arr.push({
      label: "Refund Narration",
      value: dispute?.refundTransaction?.narration,
    });
  }
  arr.push({
    label: "Created On",
    value: dispute?.createdOn,
    itemCase: "createdOn",
  });
  arr.push({
    label: "Last Modified On",
    value: dispute?.lastModifiedOn,
    itemCase: "createdOn",
  });

  return arr;
}

const transformView = (itemCase, value) => {
  let result = value;
  if (itemCase) {
    SpecialLabelCases.forEach((e) => {
      if (e.case === itemCase) {
        result = e.action(value);
      }
    });
  }
  return result;
};

function getSettlementDetails(e) {
  let arr = [];
  // setMerchantDetails([]);
  // setDetails([]);
  const dateRange = `${formatDate(e?.transactionTimeBegin)} - ${formatDate(
    e?.transactionTimeEnd
  )}`;
  // setBulkSettlementKey(e?.bulkSettlementKey);
  arr.push({ label: "Super Agent", value: e?.merchant?.merchantName });
  arr.push({
    label: "Transaction Count",
    value: e?.transactionCount,
  });
  arr.push({
    label: "Total Amount",
    value: e?.transactionTotalAmount,
    itemCase: "transactionAmount",
  });
  arr.push({
    label: "Total Transaction Charge",
    value: e?.transactionChargeAmount,
    itemCase: "transactionAmount",
  });
  arr.push({
    label: "Total VAT Amount",
    value: e?.transactionVatAmount,
    itemCase: "transactionAmount",
  });
  arr.push({
    label: "Super Agent Net Settlement",
    value: e?.transactionMerchantAmount,
    itemCase: "transactionAmount",
  });

  arr.push({ label: "Transaction Date Range", value: dateRange });
  arr.push({
    label: "Settlement Status",
    value: e?.status,
    itemCase: "status",
  });
  arr.push({ label: "Settlement Type", value: e?.settlementType });
  arr.push({
    label: "Report Status",
    value: e?.reportStatus,
    itemCase: "status",
  });
  arr.push({ label: "Bulk Settlement Key", value: e?.bulkSettlementKey });
  arr.push({
    label: "Payment Request Attempt",
    value: e?.paymentRequestAttempt,
  });
  arr.push({
    label: "Report Generation Attempt",
    value: e?.reportGenerationAttempt,
  });
  arr.push({
    label: "Created On",
    value: e?.createdAt,
    itemCase: "transactionTime",
  });
  arr.push({
    label: "Completed On",
    value: e?.completedAt,
    itemCase: "transactionTime",
  });

  // setDetails(arr);
  return arr;
}

function camelToTitleCase(inputString) {
  const words = inputString.split(/(?=[A-Z])/);
  const titleCase = words
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");

  return titleCase;
}

function getDetailsArray(data) {
  let arr = [];
  for (const prop in data) {
    // console.log("prop", prop, data);
    if (data.hasOwnProperty(prop)) {
      if (typeof data[prop] === "string" || typeof data[prop] === "number") {
        arr.push({
          label: camelToTitleCase(prop),
          value: String(data[prop]),
          itemCase: prop,
        });
      }
    }
  }
  return arr;
}

export const HELPER = {
  TO_CURRENCY_FORMAT: toCurrencyFormat,
  TO_NUMBER_FORMAT: toNumberFormat,
  FORMAT_DATE: formatDate,
  TO_MAJOR_AMOUNT: toMajorAmount,
  TO_MINOR_AMOUNT: toMinorAmount,
  FORMAT_DATE_ONLY: formatDateOnly,
  FORMAT_DATE_IN_MILLISECONDS: formatDateInMilliseconds,
  RESPONSE_CODE_COLOR: responseCodeColor,
  RESPONSE_STATUS: responseStatus,
  SETTLEMENT_WARNING_STATUS: settlementWarningStatus,
  PROCESS_ERROR: getProcessError,
  TO_URL_STRING: toUrlString,
  GET_ROLE: getRefineRole,
  HAS_AUTHORITY: hasAuthority,
  HAS_ROLE: hasRole,
  CAN_PERFORM_ACTION: canPerformAction,
  TITLE_CASE: toTitleCase,
  SET_COUNTDOWN: setCountdown,
  GET_EXPIRY_HOUR: getExpiryHour,
  GET_USER_LOGIN_ROUTE: getUserLoginRoute,
  PARSE_BLOB_ERROR: parseBlobError,
  PERCENTAGE_STATUS: percentageStatus,
  GET_DATE_DIFFERENCE: getDateDifference,
  TRIM_OBJECT: removeEmptyValues,
  GET_DISPUTE_DETAILS_ARRAY: getDisputeDetailsArray,
  TRANSFORM_VIEW: transformView,
  GET_SETTLEMENT_DETAILS: getSettlementDetails,
  CAMEL_TO_TITLE_CASE: camelToTitleCase,
  GET_DETAILS_ARRAY: getDetailsArray,
  HAS_FILTER_VALUES: hasFilterValues,
  FORMAT_ENUM: (value) => (value ? value.toString().replace(/_/g, " ") : value),
};
